import { format } from 'date-fns';

export const routerPath = {
  root: '/user-access-report-gym-Facility-admin',
};

export const getColumns = () => [
  {
    id: 'visitTime',
    label: 'Date/Time',
    customValue: (val) => format(new Date(val.visitTime), 'dd MMMM yyyy pp'),
    align: 'left',
    nameForSort: 'visit_date',
  },
  { id: 'facilityName', label: 'Facility Name', align: 'center', nameForSort: 'facility_name' },
  { id: 'userName', label: 'Name', align: 'center', disableSort: true },
  { id: 'userSex', label: 'Sex', align: 'center', nameForSort: 'user_sex' },
  { id: 'userAge', label: 'Age', align: 'center', nameForSort: 'user_age' },
];

export const getFilters = ({ searchByName, dateRange, removeDuplicates }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by name...',
    action: searchByName.change,
  },
  {
    id: 'active',
    type: 'switch',
    label: 'Remove Duplicates',
    value: removeDuplicates.value === 'true',
    action: removeDuplicates.change,
  },
  {
    id: 'dateRange',
    variant: 'dateTime',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
];
